import { GET_PARTNER_DATA } from './types';

export const getData = prefix => ({
	type: GET_PARTNER_DATA,
	prefix,
});
